import { getTs } from 'webapp/utils/common';

export const AGENTIC_INTRO_MESSAGE_SOURCE = 'agentic-databox-intro';

// Must match the <title> of public/agentic-intro/index.html - it's how the popup
// tells the real intro page apart from whatever the server falls back to (e.g. the
// SPA shell for a 404) when it validates the iframe on load.
export const AGENTIC_INTRO_TITLE = 'Welcome to new Agentic Databox';

// Launch of "Agentic Databox": 2026-09-10 16:00 Europe/Ljubljana (CEST, UTC+2).
// The intro is shown to users created before this, and only once this moment has passed.
export const AGENTIC_LAUNCH_TS = getTs('2026-09-10 14:00:00');

// Messages the intro page posts to the host (see the INTRO repo's README): `ready` once
// it has mounted, then one of the three closing CTAs - the only way to dismiss it.
export type AgenticIntroAction = 'ready' | 'open-genie' | 'book-call' | 'close';

const KNOWN_ACTIONS: AgenticIntroAction[] = ['ready', 'open-genie', 'book-call', 'close'];

export function hasAgenticIntroLaunched(nowTs = Date.now() / 1000): boolean {
	return nowTs >= AGENTIC_LAUNCH_TS;
}

// Only existing users get the announcement - anyone who signed up after the launch
// already lands in the new product.
export function wasCreatedBeforeAgenticLaunch(userCreatedTs: number | undefined): boolean {
	return !!userCreatedTs && userCreatedTs < AGENTIC_LAUNCH_TS;
}

export function getAgenticIntroAction(
	event: MessageEvent,
	expectedOrigin: string,
): AgenticIntroAction | null {
	if (event.origin !== expectedOrigin) {
		return null;
	}

	const data = event.data as { source?: unknown; action?: unknown } | null;

	if (!data || typeof data !== 'object' || data.source !== AGENTIC_INTRO_MESSAGE_SOURCE) {
		return null;
	}

	const action = data.action as AgenticIntroAction;

	return KNOWN_ACTIONS.includes(action) ? action : null;
}

export function isAgenticIntroDocument(doc: Document | null | undefined): boolean {
	return !!doc && doc.title === AGENTIC_INTRO_TITLE && !!doc.getElementById('root');
}
